import { on } from '@ember/modifier';
import type { TOC } from '@ember/component/template-only';

export interface TioQuicklinkButtonSignature {
  Args: {
    buttonText: string;
    isDisabled?: boolean;
    method: () => void;
  };
  Element: HTMLButtonElement;
}

const TioQuicklinkButton: TOC<TioQuicklinkButtonSignature> = <template>
  <button
    type="button"
    {{on "click" @method}}
    disabled={{if @isDisabled true false}}
    class="text-lg bg-white h-10 text-md text-gray-600 align-right p-2 w-full
      {{unless @isDisabled 'hover:bg-gray-200 hover:cursor-pointer hover:p-full'}}
      {{if @isDisabled '!text-gray-200'}}
      "
  >
    {{@buttonText}}
  </button>
</template>;

export default TioQuicklinkButton;
